/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MedicalAlertIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaNotifications from 'DesignSystem/Svgs/TysiaNotifications/index'



/** @type {import('Simple/types.js').View} */
export default function MedicalAlertIcon({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/AlertIcon/MedicalAlertIcon"
  
}) {
let dtColorsOrange400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.400'
        })
  return (<React.Fragment
>
<TysiaNotifications
  viewPath={`${viewPath}/TysiaNotifications`}
 width={32}
 height={32}
 fill={dtColorsOrange400}
/>
{children}
</React.Fragment>)
}